import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import SEOUpdater from '../../utils/hoc/SEOUpdater';
import PagesHeroSection from '../../components/pagesHeroSection/pagesHeroSection';
import './privacyPolicy.scss';

const PrivacyPolicyPage = () => {
  const { t } = useTranslation('privacyPolicy');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="privacyPolicyPage">
      {/* Dynamic SEO metadata */}
      <SEOUpdater page="privacyPolicy" />

      {/* Hero section */}
      <PagesHeroSection page={t('heroTitle')} />

      {/* Policy Content */}
      <div className="container py-4">
        {/* Dates */}
        <p>
          <strong>{t('effectiveDate')}</strong>
        </p>
        <p>
          <strong>{t('lastUpdated')}</strong>
        </p>

        {/* Section 1 */}
        <h4>{t('section1Title')}</h4>
        <p>{t('section1Paragraph1')}</p>
        <p>{t('section1Paragraph2')}</p>

        {/* Section 2 */}
        <h4>{t('section2Title')}</h4>
        <p>{t('section2Paragraph1')}</p>
        <p>{t('section2Paragraph2')}</p>
        <p>{t('section2Paragraph3')}</p>

        {/* Section 3 */}
        <h4>{t('section3Title')}</h4>
        <p>{t('section3Paragraph')}</p>

        {/* Section 4 */}
        <h4>{t('section4Title')}</h4>
        <p>{t('section4Paragraph')}</p>

        {/* Section 5 */}
        <h4>{t('section5Title')}</h4>
        <p>{t('section5Paragraph')}</p>

        {/* Section 6 */}
        <h4>{t('section6Title')}</h4>
        <p>{t('section6Paragraph1')}</p>
        <p>{t('section6Paragraph2')}</p>

        {/* Section 7 */}
        <h4>{t('section7Title')}</h4>
        <p>{t('section7Paragraph')}</p>

        {/* Section 8 */}
        <h4>{t('section8Title')}</h4>
        <p>{t('section8Paragraph')}</p>

        {/* Section 9 */}
        <h4>{t('section9Title')}</h4>
        <p>{t('section9Paragraph')}</p>

        {/* Section 10 - Contact Info */}
        <h4>{t('section10Title')}</h4>
        <p>{t('section10Paragraph')}</p>
        <ul>
          <li>{t('contactName')}</li>
          <li>{t('contactEmail')}</li>
          <li>{t('contactPhone')}</li>
          <li>{t('contactLocations')}</li>
          <li>{t('contactWebsite')}</li>
        </ul>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
